/** Legacy map deep-link redirect (UX spec §3.8, D-3). The map lived at `/`
 *  and deep links were `/?feature=<Type>:<id>`; the map now lives at /map.
 *  The `/` route calls this BEFORE rendering the Home page: a present
 *  `feature` param redirects to /map with the FULL query preserved, so
 *  MapPage's read-once-then-strip effect sees exactly what it used to. */

export function legacyFeatureRedirectTarget(search: string): string | null {
  const params = new URLSearchParams(search)
  if (!params.get('feature')) return null
  return `/map?${params.toString()}`
}
